
export class Locker {
    constructor(
        public id: number = null,
        public legalDescription: string = '',
        public lockerKeyCode: string = '',
        public rentedOut: number = 0,
        public rentedTo: string = '',
        public note: string = '',
        public level: string = '',
        public roomNumber: string = '',
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public extendedRentedTo: any = {},
        public formFields = {
            legalDescription: {editMode: false},
            lockerKeyCode: {editMode: false},
            rentedOut: {editMode: false},
            rentedTo: {editMode: false},
            rentedToBuilding: {editMode: false},
            rentedToSuite: {editMode: false},
            rentedToSuiteUser: {editMode: false},
            note: {editMode: false},
            level: {editMode: false},
            roomNumber: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Locker.ts